export default __webpack_public_path__ + "static/media/UBCCounsellingServiceBG.727fcb80.jpg";